import Api from "../api";
let uri = '/api/ed/nivel';

export const getNivelesSatisfaccion = () => {
    return Api.getInstance().executeGetQuery(uri)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const createNivelSatisfaccion = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const editNivelSatisfaccion = (data)  => {
    return Api.getInstance().executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}



